/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис синхронизации с Dadata
 */

/**
 * Сервис синхронизации с Dadata
 */
export class DaDataSyncServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод синхронизации дома по ОРПОНу.
   * Метод доступен для: admin, service
   */
  PostSyncOrpon = (req: PostSyncOrponRequestDto, init?: RequestInit): Promise<PostSyncOrponResponseDto> => {
    return fm.request<PostSyncOrponRequestDto, PostSyncOrponResponseDto>(`${this.host}/dadata/api/v1/sync/orpon/${encodeURIComponent(req.orpon)}`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос синхронизации дома по ОРПОНу
 */
export type PostSyncOrponRequestDto = {
  /**
   * ОРПОН дома.
   * # Диапазон: 1..9223372036854775807
   */
  orpon: string
}
/**
 * Ответ на запрос синхронизации дома по ОРПОНу
 */
export type PostSyncOrponResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostSyncOrponResponseErrorDto
}>
/**
 * Ошибка
 */
export type PostSyncOrponResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type PostSyncOrponResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос синхронизации дома по ОРПОНу
   */
  "PostSyncOrponRequest": {
    "kind": "class",
    "text": "Запрос синхронизации дома по ОРПОНу",
    "fields": {
      /**
       * ОРПОН дома.
       * # Диапазон: 1..9223372036854775807
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН дома.\n# Диапазон: 1..9223372036854775807",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 9223372036854775807,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9223372036854775807"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос синхронизации дома по ОРПОНу
   */
  "PostSyncOrponResponse": {
    "kind": "class",
    "text": "Ответ на запрос синхронизации дома по ОРПОНу",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostSyncOrponResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "PostSyncOrponResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}